module.exports = "<div [ngClass]=\"{ 'fade-in': fadeIn, item: true, one: true }\" (click)=\"load()\">{{ text }}</div>\n"